(() => {
  const initialized = new WeakSet();

  const setup = (sticky) => {
    if (initialized.has(sticky) || sticky.dataset.blumeryTwoStage !== 'true') return;
    initialized.add(sticky);

    const section = sticky.closest('.shopify-section');
    const buyButtons = section?.querySelector('.buy-buttons-block');
    const bar = sticky.querySelector('[ref="stickyBar"]');
    if (!buyButtons || !bar) return;

    let mainButton = buyButtons.querySelector('[ref="addToCartButton"], .add-to-cart-button');
    let stickyButton = sticky.querySelector('[ref="addToCartButton"]');
    if (!mainButton || !stickyButton) return;

    let frame = 0;
    let stage = '0';

    const setLabel = (nextStage) => {
      const label = sticky.querySelector('.add-to-cart-text__content > span:first-child');
      if (!label) return;
      const text = nextStage === '2' ? sticky.dataset.stageTwoLabel : sticky.dataset.stageOneLabel;
      if (text && label.textContent !== text) label.textContent = text;
    };

    const ensureStickyPills = () => {
      if (bar.querySelector('.blm-sticky-purchase-pills')) return;
      const source = section.querySelector('.blm-palmera-purchase-pills');
      if (!source) return;

      const clone = source.cloneNode(true);
      clone.classList.add('blm-sticky-purchase-pills');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      bar.insertBefore(clone, stickyButton);
    };

    const matchMainButton = () => {
      const styles = getComputedStyle(mainButton);
      [
        'background-color',
        'color',
        'border-color',
        'border-width',
        'border-style',
        'border-radius',
        'font-family',
        'font-size',
        'font-weight',
        'letter-spacing',
        'text-transform',
      ].forEach((property) => stickyButton.style.setProperty(property, styles.getPropertyValue(property)));
      stickyButton.style.minHeight = `${mainButton.getBoundingClientRect().height}px`;
    };

    const update = () => {
      frame = 0;
      mainButton = buyButtons.querySelector('[ref="addToCartButton"], .add-to-cart-button');
      stickyButton = sticky.querySelector('[ref="addToCartButton"]');
      if (!mainButton || !stickyButton) return;

      ensureStickyPills();
      matchMainButton();

      const mainButtonRect = mainButton.getBoundingClientRect();
      const stickyButtonRect = stickyButton.getBoundingClientRect();
      const mainButtonCenter = mainButtonRect.top + mainButtonRect.height / 2;
      const stickyButtonCenter = stickyButtonRect.top + stickyButtonRect.height / 2;
      const isBeforeAtc = mainButtonCenter > stickyButtonCenter + 3;
      const isPastAtc = mainButtonRect.bottom <= 0;
      let nextStage = '0';

      if (isBeforeAtc) nextStage = '1';
      else if (isPastAtc) nextStage = '2';

      if (nextStage !== stage) {
        stage = nextStage;
        sticky.dataset.stage = stage;
        sticky.dataset.stageChanging = 'true';
        clearTimeout(sticky._blumeryStageTimer);
        sticky._blumeryStageTimer = setTimeout(() => {
          delete sticky.dataset.stageChanging;
        }, 300);
      }

      bar.dataset.stuck = stage === '0' ? 'false' : 'true';
      setLabel(stage);
    };

    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    const observer = new MutationObserver(schedule);
    observer.observe(bar, { childList: true, subtree: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll?.('sticky-add-to-cart[data-blumery-two-stage="true"]').forEach(setup);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
